export default __webpack_public_path__ + "static/media/secure.877a72dc.png";